import { cn } from "@/lib/utils";
import type { PlayerData } from "./PlayerArea";

interface ScoreboardProps {
  players: PlayerData[];
  scores: Record<string, number>;
  currentTurnPlayer: string;
  myUsername: string;
  scoreLimit?: number;
}

export default function Scoreboard({ players, scores, currentTurnPlayer, myUsername, scoreLimit = 200 }: ScoreboardProps) {
  const sortedPlayers = [...players].sort(
    (a, b) => (scores[b.username] ?? 0) - (scores[a.username] ?? 0)
  );

  return (
    <div className="win2k-inset bg-[var(--win2k-white)] p-1.5">
      <div className="text-[10px] font-bold text-[var(--win2k-button-text)] mb-1 px-0.5">
        SCOREBOARD
      </div>
      <div className="space-y-0.5">
        {sortedPlayers.map((player) => {
          if (!player) return null;
          const total = scores[player.username] ?? 0;
          const isMe = player.username === myUsername;
          const isTurn = player.username === currentTurnPlayer;
          const progressPct = Math.min((total / scoreLimit) * 100, 100);

          return (
            <div
              key={player.username}
              className={cn(
                "flex items-center gap-1 px-1 py-0.5 text-[10px] md:text-[11px]",
                isMe && "bg-[var(--win2k-title-blue-start)] text-white font-bold"
              )}
            >
              <span className="truncate flex-1 min-w-0 font-bold">
                {isTurn && "▸ "}{player.autoplay_mode && "🤖 "}{player.username}
              </span>
              <div className="w-12 h-1.5 bg-gray-300 rounded-sm overflow-hidden">
                <div
                  className={cn(
                    "h-full transition-all",
                    isMe ? "bg-white" : "bg-[var(--win2k-title-blue-start)]"
                  )}
                  style={{ width: `${progressPct}%` }}
                />
              </div>
              <span className="font-mono w-8 text-right tabular-nums">
                {total}
              </span>
            </div>
          );
        })}
      </div>
      <div className="mt-1 px-0.5 text-[9px] text-[var(--win2k-shadow)]">
        First to {scoreLimit} wins
      </div>
    </div>
  );
}
